export const ordersQuantityMap = [
	{ name: '10', value: '10' },
	{ name: '20', value: '20' },
	{ name: '30', value: '30' },
	{ name: '50', value: '50' },
	{ name: '100', value: '100' },
	{ name: '200', value: '200' },
]
